// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bhs_jk","CommentListPlaceholder--Legacy":"ih_b bhs_rc bhs_wq"};